import * as React from 'react';
import { Link } from 'react-router-dom';

interface RunSheetDriverUpdateList {
    loading: boolean;
}

interface RunSheetDriverListProps {
    jobs: Job[];
    gotoCallout(jobIndex: number): void;
    gotoPlanChanges(jobIndex: number): void;
    gotoOfficeUpdate(jobIndex: number): void;
}

interface Job {
    runsheetId: number;
    scheduleDateFormatted: string;
    truck: string;
    jobId: number;
    siteAddress: string;
    updateTypeId: number;     //1=Callout, 2=Plan Changes
}

export default class RunSheetDriverList extends React.Component<RunSheetDriverListProps, RunSheetDriverUpdateList> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: false
        };
    }

    gotoCallout = (jobIndex: number) => {
        this.props.gotoCallout(jobIndex);
    }

    gotoPlanChanges = (jobIndex: number) => {
        this.props.gotoPlanChanges(jobIndex);
    }

    gotoOfficeUpdate = (jobIndex: number) => {
        this.props.gotoOfficeUpdate(jobIndex);
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
            <h4>Jobs requiring Plan Changes or Callouts</h4>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let jobs = this.props.jobs;

        return (
            <div className="">
                <div className="table__margin overflowAuto">
                    <table className="table table__large table--nowidth tableColours">
                        <thead>
                            <tr>
                                <th className="hidden">Id</th>
                                <th></th>
                                <th>Date</th>
                                <th>Truck</th>
                                <th>Job Id</th>
                                <th>Site Address</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {jobs.map((job, index) =>
                            
                                <tr key={index}>
                                    <td className="hidden">{job.runsheetId}</td>
                                    <td className="table__text--align">{index + 1}</td>
                                    <td className="table__text--align">{job.scheduleDateFormatted}</td>
                                    <td className="table__text--align"> {job.truck}</td>
                                    <td className="table__text--align"> {job.jobId}</td>
                                    <td className="table__text--align">
                                        <Link className={job.jobId === 0 ? "hidden" : ""} to={'/job/' + job.jobId + "/details"} target="_blank">
                                            {job.siteAddress}
                                        </Link>
                                        <div className={job.jobId === 0 ? "" : "hidden"}>{job.siteAddress}</div>
                                    </td>
                                    <td className="table__text--align">
                                        <button type="button" className={job.updateTypeId === 1 ? "button--round button--round--med makebackgroundlightred" : "hidden"} onClick={() => this.gotoCallout(index)}>Callout</button>
                                        <button type="button" className={job.updateTypeId === 2 ? "button--round button--round--med makebackgroundlightgreen" : "hidden"} onClick={() => this.gotoPlanChanges(index)}>Plan Changes</button>
                                        <button type="button" className={job.updateTypeId === 3 ? "button--round button--round--med makebackgroundlightblue" : "hidden"} onClick={() => this.gotoOfficeUpdate(index)}>Office Update</button>
                                    </td>
                                </tr>
                            )}
                        </tbody>                                
                    </table>
                </div>
            </div>
        );
    }

};

